import type { Command } from '@commander-js/extra-typings';
import type { ErrorReporter } from '@wix/cli-error-reporting';
import type { BiLogger } from '@wix/cli-telemetry';
import { wixCliCliError } from '@wix/bi-logger-dev-tools-data/v2';
import { createEnv } from '@wix/cli-env';
import { getUnknownFailureMessage, isCliSystemError } from '@wix/cli-error';
import {
  createBiLogger as createCliBiLogger,
  reportCommandStartEvent as originalReportCommandStartEvent,
} from '@wix/cli-telemetry';
import packageJson from '../package.json' with { type: 'json' };

export { addUserFields } from '@wix/cli-telemetry';

export const createBiLogger = async (
  cliSessionId: string,
  errorReporter: ErrorReporter,
  userId?: string
) => {
  const biLogger = await createCliBiLogger({ cliSessionId }, userId);
  const { cliEnvName, cliTrackingId } = createEnv();

  if (cliEnvName) {
    biLogger.updateDefaults({ environment: cliEnvName });
  }

  if (cliTrackingId) {
    biLogger.updateDefaults({ tracking_id: cliTrackingId });
  }

  errorReporter.on('errorReported', (error) => {
    void biLogger.report(
      wixCliCliError({
        errorMessage: getUnknownFailureMessage(error),
        errorName: error.name,
        errorType: isCliSystemError(error) ? 'SystemError' : 'UserError',
      })
    );
  });

  return {
    biLogger,
  };
};

export const reportCommandStartEvent = (
  biLogger: BiLogger,
  command: Command<unknown[]>
) => {
  return originalReportCommandStartEvent({
    biLogger,
    cliVersion: packageJson.version,
    command,
    flow: null,
  });
};
